import React from 'react';
import ToolCard from '../Shared/ToolCard';
import { motion } from 'framer-motion';

const ServerHackingTools = () => {
  const tools = [
    {
      icon: 'fa-terminal',
      iconColor: 'text-accent-pink bg-accent-pink',
      title: 'RCON Hacking',
      description: 'Brute force RCON ports and passwords to gain admin access to target servers.',
      stats: [
        { label: 'Success Rate', value: '68%', colorClass: 'text-accent-pink' },
        { label: 'Passwords', value: '724', colorClass: 'text-white' },
      ],
      gradientClass: 'gradient-bg-pink',
      path: '/rcon-hacking'
    },
    {
      icon: 'fa-database',
      iconColor: 'text-accent-blue bg-accent-blue',
      title: 'Data Extraction',
      description: 'Extract MOTD, plugins, player data, server icons and configuration files.',
      stats: [
        { label: 'Data Extracted', value: '1.2TB', colorClass: 'text-accent-blue' },
        { label: 'Servers', value: '3,421', colorClass: 'text-white' },
      ],
      gradientClass: 'gradient-bg-blue',
      path: '/server-data-extraction'
    },
    {
      icon: 'fa-network-wired',
      iconColor: 'text-accent-red bg-accent-red',
      title: 'DDoS Testing',
      description: 'Test server resilience with bot floods and packet attacks to identify weaknesses.',
      stats: [
        { label: 'Bot Mode', value: 'Available', colorClass: 'text-accent-red' },
        { label: 'Packet Mode', value: 'Available', colorClass: 'text-white' },
      ],
      gradientClass: 'gradient-bg-red',
      path: '/ddos'
    },
  ];

  return (
    <div className="mb-8 transform-gpu transition-medium hover:scale-[1.005]">
      <h2 className="text-2xl font-bold mb-5 flex items-center group">
        <div className="w-10 h-10 rounded-lg bg-accent-purple/20 flex items-center justify-center mr-3 transform-gpu group-hover:rotate-12 transition-medium">
          <i className="fas fa-shield-alt text-accent-purple"></i>
        </div>
        Server Hacking Tools
        <div className="ml-3 text-xs py-1 px-2 bg-accent-purple/20 rounded-full text-accent-purple opacity-0 group-hover:opacity-100 transition-medium">
          3 tools available
        </div>
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
      {tools.map((tool, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
          >
            <ToolCard {...tool} />
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ServerHackingTools;